import { UnexpectedArgument } from './unexpected-argument.error';

export class Fail {
    static never(value: never) {
        throw new UnexpectedArgument('unexpected value', value);
    }
}
